// # services
import { auth } from "@/services";

(function (angular) {
  "use strict";

  angular.module("app").service("Events", events);

  events.$inject = ["$q", "modalService"];

  function events($q, modalService) {
    /**
     * Opens a modal allowing a user to create an event
     * @return {object} - modalService containing result.then
     */
    function createEvent() {
      const deferred = $q.defer();

      // reject if user can't create events
      if (!auth.hasPermission("events.create")) {
        deferred.reject("Cannot create new event; permission denied.");
        return { result: deferred.promise };
      }

      modalService
        .open({
          templateUrl: "modals/manage-event.html",
          controller: "manageEventController",
          controllerAs: "vm",
          windowClass: "manage-event",
          resolve: {
            eventId: () => null,
          },
        })
        .result.then(deferred.resolve)
        .catch(deferred.reject);

      return {
        result: deferred.promise,
      };
    }

    /**
     * Opens a modal allowing a user to edit an event
     * @param  {int} eventId - ID of event
     * @return {object} - modalService containing result.then
     */
    function editEvent(eventId) {
      if (!eventId) {
        return false;
      }

      return modalService.open({
        templateUrl: "modals/manage-event.html",
        controller: "manageEventController",
        controllerAs: "vm",
        windowClass: "manage-event",
        resolve: {
          eventId: function () {
            return eventId;
          },
        },
      });
    }

    /**
     * Opens a modal allowing the user to manage an order for an event.
     * @param  {int} eventId - ID of the event
     * @param  {int} ticketId - ID of the ticket
     * @return {object}      - modalService containing result.then
     */
    function manageAttendance(eventId, ticketId) {
      return modalService.open({
        templateUrl: "modals/manage-attendance.html",
        controller: "manageAttendanceController",
        resolve: {
          eventId: function () {
            return eventId;
          },
          ticketId: function () {
            return ticketId;
          },
        },
        windowClass: "manage-attendance",
      });
    }

    return {
      manageAttendance: manageAttendance,
      create: createEvent,
      edit: editEvent,
    };
  }
})(angular);
